import fieldTechLogo from '@/assets/field-tech-logo.png';

/** Bundled login logo (matches southernmint `LogoTransparent` / field tech app icon). */
export const LOGIN_LOGO_SRC = fieldTechLogo;

/** Login logo container — matches southernmint LoginView (max 200×120, aspect fit). */
export const LOGIN_LOGO_MAX_WIDTH_PX = 200;
export const LOGIN_LOGO_MAX_HEIGHT_PX = 120;

/** When no business unit horizontal logo is configured. */
export const DEFAULT_BUSINESS_UNIT_LOGO_URL =
  'https://qualabi-public.s3.us-west-2.amazonaws.com/ui/souther_mint_horizontal_text_logo.png';

/** Fixed app bar height (MUI Toolbar default). Drawer and main content align to this. */
export const APP_BAR_HEIGHT_PX = 64;

/** Max height for horizontal logos in the app bar and expanded sidebar branding (matches Toolbar padding). */
export const APP_BAR_LOGO_MAX_HEIGHT_PX = APP_BAR_HEIGHT_PX - 16;
